import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSessionService } from '../app-session/app-session.service';
import { Observable, throwError } from 'rxjs';
import { FilterOperation } from 'src/app/models/custom-table/custom-table.model';
import { setSimpleFilterQuery, setAdvancedFilterQuery } from '../../utils/tableUtils';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GuideService {
  private GUIDES_URL =
    this.appSession.baseUrl + "/api/v1/multimedia/guides";
  
  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) { }

  getGuide(code: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${this.GUIDES_URL}/${code}`;
    return this.http.get<any>(url, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }

  createGuide(
    guide: { 
      name: string; 
      schedules: any;
    }): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(guide);
    const url = `${this.GUIDES_URL}`;
    return this.http.post<any>(url, data, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }

  updateGuide(
    guide: { 
      name: string; 
      schedules: any
    },
    id: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(guide);
    const url = `${this.GUIDES_URL}/${id}`;
    return this.http
      .put<any>(url, data, { headers })
      .pipe(
        map(({ result }) => result),
        catchError((error) => throwError(error))
      );
  }

  deleteGuide(id: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${this.GUIDES_URL}/${id}`;
    return this.http
      .delete(url, { headers })
      .pipe(catchError((error) => throwError(error)));
  }

  getGuidesList(
      paging?: any,
      filteringArgs?: any,
      sortingArgs?: any,
      advancedFilteringArgs?: any
    ): Observable<any> {
      const headers = this.setHeaders(
        filteringArgs,
        sortingArgs,
        advancedFilteringArgs
      );
  
      return this.http.get<any>(
        this.GUIDES_URL + `?${this._buildScrollExpression(paging)}`,
        { headers }
      );
    }
  
    setHeaders(
      filteringArgs?: any,
      sortingArgs?: any,
      advancedFilteringArgs?: any
    ) {
      let headers = new HttpHeaders({
        "Content-type": "application/json",
      });
  
      let filterQuery = "";
      let advancedFilterQuery = "";
      let orderQuery = "";
  
      if (filteringArgs) {
        filterQuery = setSimpleFilterQuery(filteringArgs);
      }
  
      if (advancedFilteringArgs) {
        advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
      }
  
      if (sortingArgs) {
        const { active, direction } = sortingArgs;
        orderQuery += active + "," + direction.toUpperCase();
      }
  
      if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
        headers = headers.append(
          "query",
          `${filterQuery} ${
            filterQuery.length > 0 && advancedFilterQuery.length > 0
              ? FilterOperation.AND
              : ""
          } ${advancedFilterQuery}`
        );
      }
  
      if (orderQuery.length > 0) {
        headers = headers.append("sort", orderQuery);
      }
  
      return headers;
    }
  
    private _buildScrollExpression(pagingArgs): string {
      const skip = pagingArgs.skip;
      const top = pagingArgs.top;
      const realSize = pagingArgs.realSize;
  
      if (top && top !== null) {
        return `real_size=${!!realSize}&offset=${skip}&limit=${top}`;
      } else {
        return `real_size=${!!realSize}&offset=${skip}`;
      }
    }
}
